const common = {
  minWidth: '256px',
  height: '64px',
  borderRadius: '4px'
}

export const web = {
  ...common,

  minWidth: '200px',
  height: '36px'
}

export const tablet = {
  ...common
}

export const website = {
  ...web,
  borderRadius: '18px',
  borderColor: '#000',
  borderStyle: 'solid',
  borderWidth: '1px'
}
